import React from 'react';

import { ReactComponent as SuccessIcon } from '../../../assets/images/checkCircle.svg';
import { defaultSubTitle } from '../../../hooks/useMFA/constants';
import StepHeader from '../StepHeader/StepHeader';
import { Header, HeaderText, Message, MultiFactorAuthEnabledWrapper } from './styled';

const MultiFactorAuthEnabled = (): JSX.Element => {
  return (
    <>
      <StepHeader subTitle={defaultSubTitle} />
      <MultiFactorAuthEnabledWrapper>
        <Header>
          <SuccessIcon /> <HeaderText>Success</HeaderText>
        </Header>
        <Message>Multifactor authentication has been enabled.</Message>
      </MultiFactorAuthEnabledWrapper>
    </>
  );
};

export default MultiFactorAuthEnabled;
